var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-float-action-button f fh",on:{"click":_vm.onFloatActionButton}},[_c('v-icon',{attrs:{"color":"#FFF"}},[_vm._v("edit")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }